import * as React from "react";

export interface SEOProps {
  metaDesc?: string;
  opengraphTitle: string;
  opengraphAuthor?: string;
  lang?: string;
  meta?: Array<{ name: string; content: string }>;
  focuskw?: string;
}

const Seo: React.FC<SEOProps> = ({
  metaDesc = "",
  opengraphTitle = "",
  opengraphAuthor = "",
  lang = "en",
  meta = [],
  focuskw = "",
}: SEOProps) => {
  return (
    <>
      <title>{opengraphTitle}</title>
      <meta name="description" content={metaDesc} />
      <meta name="author" content={opengraphAuthor} />
      <meta name="lang" content={lang} />
      <meta name="keywords" content={focuskw} />
      {meta.map((m, index) => (
        <meta key={index} name={m.name} content={m.content} />
      ))}
    </>
  );
};

export default Seo;
